
export default function SuitableFor() {
  const suitable = [
    {
      icon: 'ri-shopping-cart-line',
      title: 'ECモールでよく買い物をする方',
      description: 'ECモールで常時3%以上の還元率。SPUを活用すれば最大16倍以上のポイントが貯まります。',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'モバイル・光回線サービスユーザー',
      description: '経済圏のサービスを使うほどSPUが上がり、ポイント還元率がアップします。',
    },
    {
      icon: 'ri-user-smile-line',
      title: '初めてクレジットカードを作る方',
      description: '年会費永年無料で審査も比較的通りやすく、ポイントも貯まりやすい。初心者に最適です。',
    },
    {
      icon: 'ri-funds-line',
      title: 'ポイント投資に興味がある方',
      description: '証券サービスでポイントを使って投資信託を購入可能。資産運用の第一歩に。',
    },
    {
      icon: 'ri-store-2-line',
      title: '街のお店でもポイントを貯めたい方',
      description: 'マクドナルド、ファミマ、すき家などポイント加盟店で貯まる・使える。',
    },
    {
      icon: 'ri-gift-line',
      title: 'キャンペーンを活用したい方',
      description: 'お買い物マラソン、スーパーSALEなど、キャンペーンでポイント大量獲得。',
    },
  ];

  const notSuitable = [
    {
      icon: 'ri-building-line',
      text: '関連サービスをほとんど使わない方（還元率のメリットが薄い）',
    },
    {
      icon: 'ri-mail-close-line',
      text: '広告メールが苦手な方（設定で減らせますが完全には止められない）',
    },
    {
      icon: 'ri-car-line',
      text: 'ETCカードを無料で持ちたい方（条件付き無料のため）',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#333333] mb-3 text-center">
          大手ECモール系カードが向いている人
        </h2>
        <p className="text-gray-600 text-center mb-12">あなたに合っているか確認しましょう</p>

        <div className="mb-12">
          <div className="bg-gradient-to-r from-[#FFF5F5] to-[#FFF0F0] rounded-xl p-6 mb-6">
            <h3 className="text-xl font-bold text-[#333333] mb-6 flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-[#4CAF50] text-2xl"></i>
              こんな方におすすめ
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              {suitable.map((item, index) => (
                <div key={index} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#4CAF50] rounded-full flex-shrink-0">
                      <i className={`${item.icon} text-white text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-[#333333] font-bold text-sm mb-1">{item.title}</h4>
                      <p className="text-gray-600 text-xs leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#FFF8F8] rounded-xl p-6 border border-[#FFE0E0]">
            <h3 className="text-xl font-bold text-[#333333] mb-4 flex items-center gap-2">
              <i className="ri-close-circle-fill text-[#FF6B6B] text-2xl"></i>
              こんな方には向いていないかも
            </h3>
            <div className="space-y-3">
              {notSuitable.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <i className="ri-close-line text-[#FF6B6B] text-lg flex-shrink-0"></i>
                  <p className="text-gray-700 text-sm">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#BF0000] to-[#E60000] rounded-xl p-8 text-center text-white">
          <p className="text-lg md:text-xl font-bold mb-2">
            <i className="ri-lightbulb-flash-line mr-2"></i>
            結論
          </p>
          <p className="text-sm md:text-base leading-relaxed">
            ECモールや関連サービスをよく利用する方には
            <strong className="text-[#FFD700]">間違いなく最強のカード</strong>です。
            年会費永年無料なので、経済圏に入る第一歩として作っておいて損はありません。
          </p>
        </div>
      </div>
    </section>
  );
}
